// extracted by mini-css-extract-plugin
export default {"container":"FinderDetails_container__b+z3v"};